import React from "react";
import { DeepMap, FieldError, useFormContext } from "react-hook-form";
import { Form } from "semantic-ui-react";
import { ControlledInput } from "../../../../../../components/ControlledForm";
import useInspection from "../../../../hooks/inspections/useInspection";
import { InspectionStatus, InspectionStatuses } from "../../citizen-inspection-list/constants/InspectionStatus";

interface IInspectionRequestRejectionMessage {
  id: string | number | undefined;
  errors: DeepMap<
    {
      inspectionRequestRejectionMessage: string | null;
    },
    FieldError
  >;
}
export default function InspectionRequestRejectionMessage({ id, errors }: IInspectionRequestRejectionMessage) {
  const { inspectionQuery } = useInspection({ id: id ?? "" });
  const { control } = useFormContext();

  const status = inspectionQuery.data?.data.attributes.status as InspectionStatus;

  // If the status is not requested, don't display the rejection message form
  if (status !== InspectionStatuses.REQUESTED) {
    return <></>;
  }

  // Otherwise, add a new form field for the rejection message
  return (
    <div className='tw-mt-4'>
      <Form.Field error={!!errors?.inspectionRequestRejectionMessage}>
        <ControlledInput
          label='Add A Message To Send To The Requester (Required If Rejecting)'
          control={control}
          name={"inspectionRequestRejectionMessage"}
          errors={errors}
          rules={{
            validate: {
              _length: (value: string | null) => {
                if (typeof value !== "string") {
                  return true;
                }
                const MAX_LENGTH = 191;
                if (value.length > MAX_LENGTH) {
                  return `Message cannot be greater than ${MAX_LENGTH} characters`;
                }
                return true;
              },
            },
          }}
        />
      </Form.Field>
    </div>
  );
}
